import { render, staticRenderFns } from "./AdminPazienteAnagraficaEditor.vue?vue&type=template&id=3c6e00cc&"
import script from "./AdminPazienteAnagraficaEditor.vue?vue&type=script&lang=js&"
export * from "./AdminPazienteAnagraficaEditor.vue?vue&type=script&lang=js&"
import style0 from "./AdminPazienteAnagraficaEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports